import Id from './Id';
import Status from './Status';
import Supplier from './Supplier';
import Customer from './Customer';
import CompletedDate from './DeliveryDate';
import CreatorUser from './CreatorUser';
import Storage from './Storage';
import ReceiptNumber from './ReceiptNumber';
import NetPrice from './NetPrice';
import GrossPrice from './GrossPrice';
import OrderNumbers from './OrderNumbers';
import Address from './Address';
import HasNoMoreDelivery from './HasNoMoreDelivery';
import Created from './Created';
import Updated from './Updated';
import Comment from './Comment';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  Status: 'Státusz',
  Supplier: 'Szállító',
  Customer: 'Átvevő',
  Address: 'Cím',
  Storage: 'Raktár',
  HasNoMoreDelivery: 'Lesz még szállítás',
  CompletedDate: 'Teljesítés dátuma',
  CreatorUser: 'Rögzítette',
  OrderNumbers: 'Megdendelésszám',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  Comment: 'Megjegyzés',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Customer',
}, {
  value: 'Address',
}, {
  value: 'OrderNumbers',
}, {
  value: 'HasNoMoreDelivery',
}, {
  value: 'Storage',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
},{
  value: 'Comment',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Status',
}, {
  value: 'HasNoMoreDelivery',
}, {
  value: 'Customer',
}, {
  value: 'Address',
}, {
  value: 'Storage',
}, {
  value: 'OrderNumbers',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  Status,
  Customer,
  Address,
  Supplier,
  Storage,
  OrderNumbers,
  CompletedDate,
  CreatorUser,
  NetPrice,
  GrossPrice,
  HasNoMoreDelivery,
  Created,
  Updated,
  Comment,
};
